import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Form from './planoContaForm';
import Aguardando from '../common/template/aguardando';
import InputPesquisa from '../common/form/inputPesquisa';
import ReactExport from 'react-export-excel-fixed-xlsx';
import { sortData } from '../common/table/sortHelper';

import {
    setModoTela,
    initForm,
    salvar,
    excluir,
    getLista
} from './planoContaActions';

const columns = [
    {
        field: 'codigo',
        type: 'text'
    },
    {
        field: 'nome',
        type: 'text'
    },
    {
        field: 'descricao_tipo',
        type: 'text'
    },
    {
        field: 'descricao_natureza',
        type: 'text'
    },
    {
        field: 'descricao_plano_conta_pai',
        type: 'text'
    },
    {
        field: 'ordem',
        type: 'number'
    },
    {
        field: 'aceita_lancamento',
        type: 'text',
        formatter: row => row.aceita_lancamento ? 'Sim' : 'Não'
    }
];

const PlanoConta = props => {

    const [linhaSelecionada, setLinhaSelecionada] = useState(null);
    const [pesquisar, setPesquisar] = useState('');
    const [sort, setSort] = useState({
        field: 'codigo',
        direction: 'asc'
    });

    useEffect(() => {
        props.getLista();
    }, []);

    const onSort = field => {
        setSort(prev => {
            let direction = 'asc';

            if (prev.field === field) {
                direction = prev.direction === 'asc'
                    ? 'desc'
                    : 'asc';
            }

            return {
                field,
                direction
            };
        });
    };

    const filtrar = () => {
        const termoPesquisa = (pesquisar || '').trim();

        const listaFiltrada = (props.lista || []).filter(item => {
            if (!termoPesquisa) {
                return true;
            }

            const texto = `
                ${item.codigo || ''}
                ${item.nome || ''}
                ${item.descricao_tipo || ''}
                ${item.descricao_natureza || ''}
                ${item.descricao_plano_conta_pai || ''}
                ${item.ordem || ''}
                ${item.aceita_lancamento ? 'Sim' : 'Não'}
                ${item.observacao || ''}
            `.toUpperCase();

            return termoPesquisa
                .toUpperCase()
                .split('+')
                .filter(item => item.trim())
                .every(item => texto.includes(item.trim()));
        });

        return sortData(
            listaFiltrada,
            sort,
            columns
        );
    };

    const montarExcel = lista => {
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

        return (
            <ExcelSheet
                data={lista.map(item => ({
                    ...item,
                    aceita_lancamento_formatado:
                        item.aceita_lancamento ? 'Sim' : 'Não'
                }))}
                name='Plano de Contas'
            >
                <ExcelColumn
                    label='Código'
                    value='codigo'
                />

                <ExcelColumn
                    label='Nome'
                    value='nome'
                />

                <ExcelColumn
                    label='Conta Pai'
                    value='descricao_plano_conta_pai'
                />

                <ExcelColumn
                    label='Tipo'
                    value='descricao_tipo'
                />

                <ExcelColumn
                    label='Natureza'
                    value='descricao_natureza'
                />

                <ExcelColumn
                    label='Aceita Lançamento'
                    value='aceita_lancamento_formatado'
                />

                <ExcelColumn
                    label='Ordem'
                    value='ordem'
                />

                <ExcelColumn
                    label='Observação'
                    value='observacao'
                />

                <ExcelColumn
                    label='Usuário da Inclusão'
                    value='nome_usuario_inclusao'
                />

                <ExcelColumn
                    label='Usuário da Alteração'
                    value='nome_usuario_alteracao'
                />
            </ExcelSheet>
        );
    };

    const abrirCadastro = () => {
        props.setModoTela('cadastro', {});

        props.initForm({
            aceita_lancamento: true,
            ordem: 0
        });
    };

    const abrirEdicao = item => {
        props.setModoTela('cadastro', {
            ...item
        });

        props.initForm({
            ...item
        });
    };

    const abrirExclusao = item => {
        props.setModoTela('exclusao', {
            ...item
        });

        props.initForm({
            ...item
        });
    };

    const renderLista = () => {
        const ExcelFile = ReactExport.ExcelFile;
        const lista = filtrar();

        const alturaTabela = window.innerWidth < 631
            ? window.innerHeight - 260
            : window.innerHeight - 180;

        return (
            <ContentCard>
                <ContentCardHeader>
                    <Row>
                        <InputPesquisa
                            cols='12 6 3 1'
                            label='Pesquisar'
                            minWidth={344}
                            onChange={value => setPesquisar(value)}
                        />

                        <div className='crud-actions'>
                            <button
                                type='button'
                                className='btn btn-app bg-success'
                                style={{ marginLeft: 2, minWidth: 75 }}
                                onClick={abrirCadastro}
                            >
                                <i className='fas fa-plus'></i>
                                Adicionar
                            </button>

                            <button
                                type='button'
                                className='btn btn-app bg-primary'
                                style={{ marginLeft: 2, minWidth: 75 }}
                                onClick={() => props.getLista()}
                            >
                                <i className='fas fa-sync-alt'></i>
                                Atualizar
                            </button>

                            <ExcelFile
                                filename='Plano de Contas'
                                element={
                                    <button
                                        type='button'
                                        className='btn btn-app bg-info'
                                        style={{ marginLeft: 2, minWidth: 75 }}
                                    >
                                        <i className='fas fa-file-excel'></i>
                                        Exportar
                                    </button>
                                }
                            >
                                {montarExcel(lista)}
                            </ExcelFile>
                        </div>
                    </Row>
                </ContentCardHeader>

                <ContentCardBody>
                    <Table
                        responsive
                        border
                        alturaFixa
                        striped
                        maxHeight={alturaTabela}
                    >
                        <THead>
                            <Tr>
                                <ThSort
                                    field='codigo'
                                    label='Código'
                                    width={100}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='nome'
                                    label='Nome'
                                    width={250}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='descricao_plano_conta_pai'
                                    label='Conta Pai'
                                    width={250}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='descricao_tipo'
                                    label='Tipo'
                                    width={120}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='descricao_natureza'
                                    label='Natureza'
                                    width={100}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='aceita_lancamento'
                                    label='Lançamento'
                                    width={100}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <ThSort
                                    field='ordem'
                                    label='Ordem'
                                    width={80}
                                    sort={sort}
                                    onSort={onSort}
                                />

                                <Th
                                    sticky
                                    alignCenter
                                    width={50}
                                />
                            </Tr>
                        </THead>

                        <TBody>
                            {lista.map((item, index) => (
                                <Tr
                                    key={item.id}
                                    backgroundColor={
                                        linhaSelecionada === item.id
                                            ? '#bcc7eb'
                                            : index % 2 === 0
                                                ? '#ffffff'
                                                : '#f5f5f5'
                                    }
                                >
                                    <Td
                                        alignCenter
                                        onClick={() =>
                                            setLinhaSelecionada(item.id)
                                        }
                                    >
                                        {item.codigo}
                                    </Td>

                                    <Td
                                        alignCenter
                                        onClick={() =>
                                            setLinhaSelecionada(item.id)
                                        }
                                    >
                                        {item.nome}
                                    </Td>

                                    <Td
                                        alignCenter
                                        onClick={() =>
                                            setLinhaSelecionada(item.id)
                                        }
                                    >
                                        {item.descricao_plano_conta_pai}
                                    </Td>

                                    <Td
                                        alignCenter
                                        onClick={() =>
                                            setLinhaSelecionada(item.id)
                                        }
                                    >
                                        {item.descricao_tipo}
                                    </Td>

                                    <Td
                                        alignCenter
                                        onClick={() =>
                                            setLinhaSelecionada(item.id)
                                        }
                                    >
                                        {item.descricao_natureza}
                                    </Td>

                                    <Td
                                        alignCenter
                                        onClick={() =>
                                            setLinhaSelecionada(item.id)
                                        }
                                    >
                                        {item.aceita_lancamento
                                            ? 'Sim'
                                            : 'Não'}
                                    </Td>

                                    <Td
                                        alignCenter
                                        onClick={() =>
                                            setLinhaSelecionada(item.id)
                                        }
                                    >
                                        {item.ordem}
                                    </Td>

                                    <Td
                                        alignCenter
                                        minWidth={130}
                                        maxWidth={130}
                                    >
                                        <ButtonTable
                                            type='warning'
                                            width={32}
                                            small
                                            icon='fas fa-pencil-alt'
                                            visible
                                            title='Editar'
                                            event={() =>
                                                abrirEdicao(item)
                                            }
                                        />

                                        <ButtonTable
                                            type='danger'
                                            width={32}
                                            small
                                            icon='fas fa-trash-alt'
                                            visible
                                            title='Excluir'
                                            event={() =>
                                                abrirExclusao(item)
                                            }
                                        />
                                    </Td>
                                </Tr>
                            ))}
                        </TBody>
                    </Table>
                </ContentCardBody>
            </ContentCard>
        );
    };

    return (
        <Content>
            <Aguardando
                aguardando={props.aguardando}
            />

            {props.modoTela === 'cadastro' &&
                <Form onSubmit={props.salvar} />}

            {props.modoTela === 'exclusao' &&
                <Form
                    excluir
                    onSubmit={props.excluir}
                />}

            {props.modoTela === 'lista' &&
                renderLista()}
        </Content>
    );
};

const mapStateToProps = state => ({
    sessao: state.auth.usuario,
    modoTela: state.planoConta.modoTela,
    aguardando: state.planoConta.aguardando,
    lista: state.planoConta.lista
});

const mapDispatchToProps = dispatch =>
    bindActionCreators({
        setModoTela,
        initForm,
        salvar,
        excluir,
        getLista
    }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PlanoConta);